/**
 * Created by rongzhx on 2017/8/11 0011.
 */
// 支持翻页的Table组件
import React, { Component, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Select } from 'antd';
import { cache } from 'utils';
import './index.less';

class PaginationList extends (PureComponent || Component) {
	constructor (props) {
		super();
		this.state = {
			// 每页数量
			pageSize: props.pageSize[0],
			// 前一页，当前页，下一页锚点
			currentPageAnchor: null,
			nextPageAnchor: null,
			prevPageAnchor: null,
			// 缓存前一页数据
			cachePrevPageAnchor: [],
			// 翻页按钮禁用状态
			nextPageAnchorDisabled: false,
			prevPageAnchorDisabled: false,
			// 当前是否在加载标记
			loading: true
		};
	}

	componentWillReceiveProps (nextProps) {
		const { pageAnchor } = nextProps;
		const { cachePrevPageAnchor } = this.state;
		// if (!clearParams) {
		// 通过props拿到的pageAnchor永远是下一页锚点。此时肯定加载完成
		this.setState({ nextPageAnchor: pageAnchor, loading: false });
		// 如果后台没有返回锚点信息说明是最后一页，下一页按钮禁用,否则不禁用
		if (pageAnchor === undefined || pageAnchor === 'undefined') {
			this.setState({ nextPageAnchorDisabled: true });
		} else {
			this.setState({ nextPageAnchorDisabled: false });
		}
		// 如果缓存中没有前一页的锚点数据说明是第一页，前一页按钮禁用
		if (cachePrevPageAnchor.length === 0) {
			this.setState({ prevPageAnchorDisabled: true });
		} else {
			this.setState({ prevPageAnchorDisabled: false });
		}
		// }

		// 清除掉当前缓存的数据
		// else if (clearParams && cacheData) {
		// 	if (cacheKey) {
		// 		cache.del(cacheKey);
		// 	} else {
		// 		cache.del('paginationList');
		// 	}

		// 	this.setState({
		// 		pageSize: this.props.pageSize[0],
		// 		currentPageAnchor: null,
		// 		nextPageAnchor: pageAnchor,
		// 		prevPageAnchor: null,
		// 		cachePrevPageAnchor: [],
		// 		nextPageAnchorDisabled: !pageAnchor,
		// 		prevPageAnchorDisabled: this.state.cachePrevPageAnchor.length == 0
		// 	});
		// }
	}

	componentDidMount () {
		// 如果是缓存了数据，需要在重新挂载组件的时候，利用缓存的数据初始化组件
		const { cacheData = true, cacheKey } = this.props;
		let cachedParams = null;
		if (cacheKey) {
			// cachedParams = cache.get(cacheKey);
			cachedParams = cache.getPageState('PaginationList', cacheKey);
		} else {
			cachedParams = cache.getPageState('PaginationList', 'paginationList');
			// cachedParams = cache.get('paginationList');
		}

		if (cacheData && cachedParams && 'pageSize' in cachedParams) {
			this.setState({
				pageSize: cachedParams.pageSize,
				currentPageAnchor: cachedParams.currentPageAnchor,
				nextPageAnchor: cachedParams.nextPageAnchor,
				prevPageAnchor: cachedParams.prevPageAnchor,
				cachePrevPageAnchor: cachedParams.cachePrevPageAnchor,
				nextPageAnchorDisabled: cachedParams.nextPageAnchorDisabled,
				prevPageAnchorDisabled: cachedParams.prevPageAnchorDisabled
			});
		} else {
			// this.props.onPageChange(this.props.pageSize[0], undefined);
		}
	}

	componentWillUnmount () {
		const { cacheData = true } = this.props;
		if (cacheData) {
			this.cachedParams();
		}
	}

  /**
	 * 如果使用了缓存，获取当前页数据；否则是第一页
	 * params：Object { success: 成功回调, error: 失败回调, otherParams: 业务自己需要的参数 }
	 */
  fetchByCacheParams = (commandObject) => {
  	const { cacheData = true, cacheKey } = this.props;
  	const { success = () => {}, error = () => {}, otherParams = {} } = commandObject || {};
  	const newCommanObject = { success, error, otherParams };
  	let cachedParams = null;
  	if (cacheKey) {
  		cachedParams = cache.getPageState('PaginationList', cacheKey);
  		// cachedParams = cache.get(cacheKey);
  	} else {
  		// cachedParams = cache.get('paginationList');
  		cachedParams = cache.getPageState('PaginationList', 'paginationList');
  	}

  	if (cacheData && cachedParams && 'pageSize' in cachedParams) {
  		this.props.onPageChange(cachedParams.pageSize, cachedParams.currentPageAnchor, newCommanObject);
  		this.setState({
  			...cachedParams
  		});
  	} else {
  		this.props.onPageChange(this.props.pageSize[0], undefined, newCommanObject);

  		this.setState({
  			pageSize: this.props.pageSize[0],
  			currentPageAnchor: null,
  			nextPageAnchor: null,
  			prevPageAnchor: null,
  			cachePrevPageAnchor: [],
  			nextPageAnchorDisabled: false,
  			prevPageAnchorDisabled: false
  		});
  	}
  	this.clearCache();
  }

  // 点击上一页
  handlePrevClick = () => {
  	const { cachePrevPageAnchor, currentPageAnchor, pageSize, loading } = this.state;
  	const { onPageChange } = this.props;
  	// 缓存删除最后一位记录，拿到该记录做当前请求的锚点
  	const prevPageAnchor = cachePrevPageAnchor.pop();

  	// 正在加载，点击没反应
  	if (loading) {
  		return;
  	}
  	// 点击上一页，当前页是缓存中的最后一个锚点，下一个页的锚点为当前页的锚点，能点击前一页，则下一个一定能点击
  	this.setState({
  		cachePrevPageAnchor,
  		currentPageAnchor: prevPageAnchor,
  		nextPageAnchor: currentPageAnchor,
  		nextPageAnchorDisabled: false
  	});
  	// 回调请求接口，把页码和请求需要的锚点传过去
  	onPageChange(pageSize, prevPageAnchor);
  }

  // 刷新当前页面的方法，在新增、修改、删除后操作，如果新增的记录不在当前页则看不到数据咯，需要上下翻页看到最新的数据(firstPageRefresh为true:刷新并回到第一页)
  refresh = (firstPageRefresh, commandObject) => {
  	const { pageSize, currentPageAnchor } = this.state;
  	this.commandObject = commandObject;
  	const { onPageChange } = this.props;
  	if (firstPageRefresh) {
  		this.setState({
  			nextPageAnchor: null,
  			currentPageAnchor: null,
  			prevPageAnchor: null,
  			cachePrevPageAnchor: [],
  			prevPageAnchorDisabled: false,
  			nextPageAnchorDisabled: false
  		});
  		this.clearCache();
  		onPageChange(pageSize, null, commandObject);
  	} else {
  		onPageChange(pageSize, currentPageAnchor);
  	}
  }

  // 点击下一页
  handleNextClick = () => {
  	const { onPageChange } = this.props;
  	const { pageSize, nextPageAnchor, currentPageAnchor, cachePrevPageAnchor, loading } = this.state;
  	// 点击下一页把当前页添加到缓存锚点中
  	cachePrevPageAnchor.push(currentPageAnchor);

  	// 正在加载，点击没反应
  	if (loading) {
  		return;
  	}

  	// 点击下一页，前一页为当前页，当前页为下一页，能点击下一页，则前一页一定可以点击
  	this.setState({
  		prevPageAnchor: currentPageAnchor,
  		cachePrevPageAnchor,
  		currentPageAnchor: nextPageAnchor,
  		prevPageAnchorDisabled: false
  	});
  	// 回调请求接口，把页码和请求需要的锚点传过去
  	onPageChange(pageSize, nextPageAnchor);
  }

  pageSizeChange = (value) => {
  	// 重置当前状态,请求第一页数据
  	this.setState({
  		pageSize: value,
  		nextPageAnchor: null,
  		currentPageAnchor: null,
  		prevPageAnchor: null,
  		cachePrevPageAnchor: [],
  		prevPageAnchorDisabled: false,
  		nextPageAnchorDisabled: false,
  		loading: false
  	});
  	// 回调请求接口，把页码和请求需要的锚点传过去，传null callApi时会不传锚点，默认返回第一页
  	this.props.onPageChange(value, null, this.commandObject);
  }

  // 缓存数据
  cachedParams = () => {
  	const state = this.state;
  	const { cacheData = true, cacheKey } = this.props;
  	if (cacheData) {
  		if (cacheKey) {
  			cache.setPageState('PaginationList', cacheKey, state);
  			// cache.set(cacheKey, state);
  		} else {
  			cache.setPageState('PaginationList', 'paginationList', state);
  			// cache.set('paginationList', state);
  		}
  	}
  }

  // 清除缓存
  clearCache = () => {
  	if ('cacheKey' in this.props) {
  		cache.delPageState('PaginationList', this.props.cacheKey);
  		// cache.del(this.props.cacheKey);
  	} else {
  		cache.delPageState('PaginationList', 'paginationList');
  		// cache.del('paginationList');
  	}
  }

	// 重置state
	resetState = () => {
		this.setState({
			// 每页数量
			pageSize: this.props.pageSize[0],
			// 前一页，当前页，下一页锚点
			currentPageAnchor: null,
			nextPageAnchor: null,
			prevPageAnchor: null,
			// 缓存前一页数据
			cachePrevPageAnchor: [],
			// 翻页按钮禁用状态
			nextPageAnchorDisabled: false,
			prevPageAnchorDisabled: false,
			// 当前是否在加载标记
			// loading: true
		});
	}

	render () {
  	const { pageSize = [10, 20, 50] } = this.props;
  	const { prevPageAnchorDisabled, nextPageAnchorDisabled } = this.state;
		return (
			<div style={{ overflow: 'hidden' }}>
				<div className='eh-paginationList'>
					<label >每页</label>
					<Select
						value={String(this.state.pageSize)}
						size="small"
						style={{ width: 55 }}
						onChange={this.pageSizeChange}
					>
						{
							pageSize.map((value, index) =>
								<Select.Option value={String(value)} key={index}>{value}</Select.Option>
							)
						}
					</Select>
					<label>条</label>
					<Button size="small" disabled={prevPageAnchorDisabled} onClick={this.handlePrevClick}><LeftOutlined /></Button>
					<Button size="small" disabled={nextPageAnchorDisabled} onClick={this.handleNextClick}><RightOutlined /></Button>
				</div>
			</div>
		);
	}
}

PaginationList.propTypes = {
	// 回调请求接口，把页码和请求需要的锚点传过去
	onPageChange: PropTypes.func,
	// 支持翻页的页数
	pageSize: PropTypes.arrayOf(PropTypes.number),
	// 锚点
	pageAnchor: PropTypes.string,
	// 缓存的key名称
	cacheKey: PropTypes.string,
	// 是否缓存。默认缓存
	cacheData: PropTypes.bool
};

export default PaginationList;
